import axios from 'axios';
import * as React from 'react';
import { requestAddListContacts } from '../asyncHelpers/listsService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { ContactsListAssignmentRequest } from '../sic-lib/types/Lists';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncAddListContacts
 *
 * @description
 * Wrapper function for managing state and request cancellation for
 * requestAddListContacts HTTP request.
 */
export default function useAsyncAddListContacts() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncAddListContacts = async (
        data: ContactsListAssignmentRequest,
    ): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            await requestAddListContacts(data.listId, data.contactIds, request_token.token);

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (e: any) {
            if (!axios.isCancel(e)) {
                if (axios.isAxiosError(e)) {
                    if (e.response?.status === 400) {
                        /* Notify user of failed http request */
                        const toastData = createErrorToast(e.response?.data);

                        dispatch(createToast({ toastData }));
                    }
                }
                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncAddListContacts,
    };
}
